import React from 'react'
import { Select } from 'components/select'
import { Label } from 'reactstrap'
import { logicOptions } from 'enums/logicOptions'

export const LogicOptions = ({ localize, column, update, classes }) => {
  
  const handleOnChange = React.useCallback((logic) => update({ logic }), [update])
  if ((column.value || []).length > 1) {
    return (
      <div className={classes.logicOptions}>
        <Label>{localize('filters.logicOperator')}</Label>
        <Select
          enum={logicOptions}
          value={column.logic}
          onChange={handleOnChange}
        />
      </div>
    )
  }
  return null
}